module.exports = __webpack_public_path__ + "img/JalaHarvest.882947e7.svg";